import { Link, NameBanner, Offer } from '@rumblefish/ui/Rumblefish23Theme';

import { dedicatedTeamServiceData } from './DedicatedTeamService.data';
import type { DedicatedTeamServiceProps } from './DedicatedTeamService.types';
import {
  SectionNameBannerStack,
  StyledButton,
  StyledLinkWrapper,
  StyledSection,
  StyledStack,
} from './styles';

export const DedicatedTeamService = ({
  offerRef,
  ...props
}: DedicatedTeamServiceProps): React.ReactElement => {
  return (
    <>
      <StyledSection width="normal">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner type="section" text="Services" color="red" />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title={dedicatedTeamServiceData.mainText}
        description={dedicatedTeamServiceData.description}
        data={dedicatedTeamServiceData.services}
        CustomButton={
          <StyledLinkWrapper>
            <Link to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </Link>
          </StyledLinkWrapper>
        }
        ref={offerRef}
      />
    </>
  );
};
